// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3v-2";
export var blackBorderOnHover = "_3v-7";
export var cell = "_3v-6";
export var cellContainer = "_3v-3";
export var checked = "_3v-8";
export var disabled = "_3v-5";
export var featuredIconCellContainer = "_3v-9";
export var featuredIconTextContainer = "_3v-b";
export var featuredIconWrapper = "_3v-a";
export var noBorder = "_3v-c";
export var orangeSelectedRow = "_bz-3";
export var overflowableText = "_3v-0";
export var overflowableTextContainer = "_3v-1";
export var row = "_3w-0";
export var rowCheckboxCell = "_3v-4";
export var selectableTable = "_bz-2";